// The admin's URL fields save `{ type, link }`. Older entries used
// `{ type, url }` and keep that stale `url` after being re-saved, so `link`
// (what the admin edits now) must win.
export function cmsLinkUrl(value) {
  if (!value) return null;
  if (typeof value === "string") return value;
  return value.link || value.url || null;
}

export function toDownloadUrl(fileUrl, filename) {
  if (!fileUrl) return null;

  let finalName = filename;
  if (finalName && !/\.[a-z0-9]+$/i.test(finalName)) {
    const urlParts = fileUrl.split('?')[0].split('/');
    const lastPart = urlParts[urlParts.length - 1];
    const match = lastPart.match(/(\.[a-z0-9]+)$/i);
    if (match) {
      finalName = `${finalName}${match[1]}`;
    }
  }

  const params = new URLSearchParams({ url: fileUrl });
  if (finalName) params.set("name", finalName);
  return `/api/download?${params.toString()}`;
}

export function resolveCmsButton(raw) {
  let btn = raw;
  while (Array.isArray(btn)) {
    btn = btn[0];
  }
  if (!btn || typeof btn !== "object") return null;
  const href =
    typeof btn.url === "object" && btn.url !== null
      ? cmsLinkUrl(btn.url)
      : btn.url || btn.link;
  if (!href || (typeof href === "string" && !href.trim())) return null;
  return btn;
}
